export type MovieType = "电影" | "电视剧";
export type MovieRegion = "国产" | "海外";

export type Movie = {
  id: string;
  title: string;
  originalTitle: string;
  type: MovieType;
  region: MovieRegion;
  year: number;
  genres: string[];
  rating: number;
  popularity: number;
  duration: string;
  director: string;
  cast: string[];
  tagline: string;
  summary: string;
  synopsis: string[];
  updatedAt: string;
  poster: string;
  still?: string;
  tags: string[];
  featured: boolean;
};

export const movies: Movie[] = [
  {
    id: "long-night",
    title: "长夜将明",
    originalTitle: "Before the Long Night Ends",
    type: "电影",
    region: "国产",
    year: 2025,
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.9,
    popularity: 98,
    duration: "128 分钟",
    director: "陈屿",
    cast: ["张译文", "李青禾", "周牧"],
    tagline: "一座不睡的城市，一桩被雨水冲淡的旧案。",
    summary: "雨夜连环失踪案重启，退休刑警与年轻记者在城市的缝隙里追查十八年前的真相。",
    synopsis: [
      "南方小城的雨季比往年来得更久。十八年前，一起未破的连环失踪案像一根倒刺，扎在所有办案人的记忆里。退休刑警陆建平在整理旧物时，发现了一份被人为抽走的卷宗附录——上面写着一个从未出现在任何记录里的名字。",
      "与此同时，年轻记者沈知意接到匿名线索，被引向城郊那间早已废弃的录像厅。两人在追寻中逐渐发现，当年所有的证词都绕不开一场大火，以及一场被刻意改写的事故报告。真相并不在卷宗里，而在每个缄口不言的人心里。",
      "影片以冷峻的雨夜影像和克制的叙事，讲述普通人在漫长黑夜里如何守住一点点微光。当最后一个证人开口，长夜终于开始松动。",
    ],
    updatedAt: "2025-10-12",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%20of%20a%20lone%20detective%20in%20a%20long%20coat%20standing%20in%20heavy%20rain%20on%20a%20night%20city%20street%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20navy%20blue%20and%20warm%20amber%20lighting%2C%20dramatic%20shadows%2C%20soft%20film%20grain%2C%20minimal%20dark%20background%2C%20high%20detail%20editorial%20photography&width=600&height=800&seq=movie-long-night-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rain%20soaked%20city%20street%20at%20night%2C%20a%20lone%20figure%20in%20a%20long%20coat%20walking%20away%20under%20street%20lamps%2C%20reflections%20on%20wet%20asphalt%2C%20deep%20navy%20blue%20and%20warm%20amber%20tones%2C%20heavy%20atmosphere%2C%20film%20grain%2C%20high%20detail%20anamorphic%20photography&width=1600&height=900&seq=still-long-night-hero&orientation=landscape",
    tags: ["年度口碑", "悬疑必看"],
    featured: true,
  },
  {
    id: "between-mountains",
    title: "山海之间",
    originalTitle: "Between Mountains and Sea",
    type: "电视剧",
    region: "国产",
    year: 2025,
    genres: ["剧情", "家庭", "年代"],
    rating: 8.6,
    popularity: 95,
    duration: "全 36 集",
    director: "林知远",
    cast: ["宋晚", "何砚", "林小满"],
    tagline: "一个家庭三代人的迁徙，藏在山谷里的三十年。",
    summary: "山村教师一家三代跨越三十年，在迁徙与留守之间，守住一座只剩七个学生的学校。",
    synopsis: [
      "故事从 1994 年的一个山谷小学开始。年轻教师宋晚被分配到这里，第一次站在只有七张课桌的教室里，听见山风穿过破旧的窗框。她想走，却在一次次家访里留了下来。",
      "三十年里，孩子们一批批走出山谷，公路修通了，老校舍拆了又建。宋晚的女儿成为纪录片导演，回来拍摄即将撤并的学校；而外孙女在镜头前问出了那个所有人都回避的问题：当年为什么不走？",
      "剧集以四季轮转的山区影像和细密的生活细节，写出一代普通人的选择。山海之间，不是距离，而是那些年里所有舍不得的理由。",
    ],
    updatedAt: "2025-10-14",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20TV%20series%20poster%20portrait%20of%20a%20small%20mountain%20village%20schoolhouse%20at%20dusk%2C%20two%20silhouetted%20figures%20walking%20along%20a%20ridge%2C%20layered%20misty%20mountains%2C%20deep%20navy%20blue%20shadows%20with%20warm%20amber%20sunset%20light%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20editorial%20photography&width=600&height=800&seq=movie-between-mountains-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20misty%20mountain%20valley%20at%20sunrise%2C%20a%20small%20village%20schoolhouse%20on%20a%20ridge%2C%20layered%20blue%20mountains%20fading%20into%20warm%20amber%20light%2C%20quiet%20and%20vast%20atmosphere%2C%20soft%20film%20grain%2C%20high%20detail%20landscape%20photography&width=1600&height=900&seq=still-between-mountains-hero&orientation=landscape",
    tags: ["家庭剧", "年度高分"],
    featured: true,
  },
  {
    id: "fog-harbor",
    title: "雾港疑云",
    originalTitle: "The Fog Harbour",
    type: "电影",
    region: "海外",
    year: 2024,
    genres: ["悬疑", "惊悚"],
    rating: 8.3,
    popularity: 91,
    duration: "116 分钟",
    director: "艾略特·万",
    cast: ["玛拉·基恩", "朱利安·雷", "诺亚·贝克"],
    tagline: "雾散之前，没有人能离开这座港口。",
    summary: "一场浓雾封锁港口小镇，失踪的灯塔看守人留下了一卷只有海浪声的录音带。",
    synopsis: [
      "北方港口小镇每年有四十天被浓雾笼罩。灯塔看守人在换班夜失踪，唯一的线索是一卷老式录音带，里面只有规律的海浪声，以及一段几乎听不见的呼吸。",
      "临时调任的港务调查员发现，镇上所有居民都记得那晚的雾，却没有人记得那晚的船。随着潮水退去，一艘不该存在的渔船搁浅在礁石之间。",
      "影片把悬疑压缩在九十分钟的雾里，用声音和留白制造压迫感。当雾终于散去，观众才发现真正可怕的，是小镇共同维护的那份沉默。",
    ],
    updatedAt: "2025-10-09",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20poster%20portrait%20of%20a%20lonely%20lighthouse%20in%20thick%20fog%20at%20a%20northern%20harbour%2C%20faint%20silhouette%20of%20a%20fishing%20boat%20on%20dark%20water%2C%20cold%20navy%20blue%20tones%20with%20a%20single%20warm%20amber%20lamp%2C%20heavy%20atmosphere%2C%20soft%20film%20grain%2C%20minimal%20dark%20background%2C%20high%20detail%20photography&width=600&height=800&seq=movie-fog-harbor-poster&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20fog%20covered%20harbour%20at%20dawn%2C%20a%20dark%20lighthouse%20silhouette%20and%20a%20small%20fishing%20boat%20on%20still%20water%2C%20cold%20navy%20blue%20tones%20with%20one%20warm%20amber%20lamp%2C%20mysterious%20atmosphere%2C%20soft%20film%20grain%2C%20high%20detail%20landscape%20photography&width=1600&height=900&seq=still-fog-harbor-hero&orientation=landscape",
    tags: ["高分悬疑", "海外佳片"],
    featured: true,
  },
  {
    id: "tide-city",
    title: "潮汐之城",
    originalTitle: "City of Tides",
    type: "电视剧",
    region: "海外",
    year: 2025,
    genres: ["剧情", "爱情", "都市"],
    rating: 8.4,
    popularity: 89,
    duration: "全 12 集",
    director: "高桥澪",
    cast: ["森川葵", "井上年", "李维安"],
    tagline: "海水每天退去两次，有些人只敢在退潮时相爱。",
    summary: "海边小城的电台主播与归乡的建筑师，在一次次潮汐里重新学习如何告别。",
    synopsis: [
      "沿海小城有一座即将拆除的旧电台，主播浅野每天凌晨播报潮汐时间，听众只有固定的一小群人。建筑师井上回到故乡，任务是把这片海岸改造成观光区。",
      "两人的相遇像一场不合时宜的涨潮。电台里未寄出的信、被海水泡过的设计图、以及一段无人认领的旧录音，慢慢拼出他们上一代人之间的往事。",
      "十二集的篇幅里，剧集用潮汐的节奏推进情感：退潮时坦白，涨潮时沉默。结尾没有大团圆，只有两个人在清晨的海边，认真地说了一句再见。",
    ],
    updatedAt: "2025-10-08",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romance%20series%20poster%20portrait%20of%20a%20woman%20standing%20on%20a%20quiet%20beach%20at%20blue%20hour%2C%20gentle%20waves%20and%20distant%20city%20lights%2C%20deep%20navy%20and%20muted%20teal%20palette%20with%20soft%20amber%20horizon%20glow%2C%20soft%20film%20grain%2C%20minimal%20elegant%20composition%2C%20high%20detail%20editorial%20photography&width=600&height=800&seq=movie-tide-city-poster&orientation=portrait",
    tags: ["治愈系", "海外剧集"],
    featured: false,
  },
  {
    id: "summer-echo",
    title: "夏日回声",
    originalTitle: "Echoes of Summer",
    type: "电影",
    region: "国产",
    year: 2024,
    genres: ["青春", "剧情"],
    rating: 8.0,
    popularity: 82,
    duration: "104 分钟",
    director: "许南",
    cast: ["沈一禾", "程野", "苏木"],
    tagline: "那年夏天的蝉鸣，一直响到很多年以后。",
    summary: "一张旧照片把三个中年人带回海边小城，找回那个没说完的夏天。",
    synopsis: [
      "毕业二十年的同学聚会上，三个人翻出一张褪色的照片：海边、旧自行车、还有一台没拍完的胶片相机。他们决定回去把最后一卷胶片洗出来。",
      "小城变了，录像厅变成了便利店，防波堤被加高了两米。但海还是那片海。三个人沿着当年的路线走了一遍，才发现记忆里那个夏天，每个人都少说了一句话。",
      "影片用温暖的日光和大量的环境声，拍出夏天真正的声音。没有戏剧化的重逢，只有成年人终于愿意承认的遗憾。",
    ],
    updatedAt: "2025-09-28",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20summer%20film%20poster%20portrait%20of%20three%20friends%20on%20an%20old%20seaside%20breakwater%20at%20golden%20hour%2C%20bicycles%20and%20film%20camera%20in%20frame%2C%20warm%20amber%20sunlight%20over%20deep%20blue%20sea%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20editorial%20photography&width=600&height=800&seq=movie-summer-echo-poster&orientation=portrait",
    tags: ["青春回忆", "治愈"],
    featured: false,
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    originalTitle: "Silent Testimony",
    type: "电视剧",
    region: "国产",
    year: 2025,
    genres: ["律政", "悬疑", "剧情"],
    rating: 8.7,
    popularity: 93,
    duration: "全 24 集",
    director: "郑岩",
    cast: ["韩书", "叶清", "顾铭"],
    tagline: "当所有人都说了真话，真相反而更远。",
    summary: "一桩证据链完美的案件，被一位手语翻译指出了一处不该存在的停顿。",
    synopsis: [
      "庭审现场，唯一的目击证人是位听障者。手语翻译在转述时，注意到证人在描述某个时间点时停顿了整整四秒——而那段证词，原本被认为是天衣无缝的。",
      "年轻检察官开始重新梳理案件，发现所有证人都没有撒谎，但每个人看到的都只是事情的一角。二十四集里，案件像一面被反复擦拭的镜子，每次都照出不同的东西。",
      "剧集聚焦程序与人性之间的缝隙，用大量庭审细节构建真实感。最后一场陈述没有煽情配乐，只有一句被完整翻译出来的证词。",
    ],
    updatedAt: "2025-10-11",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20legal%20drama%20poster%20portrait%20of%20an%20empty%20witness%20stand%20in%20a%20dim%20courtroom%2C%20shafts%20of%20cold%20light%20through%20tall%20windows%2C%20deep%20navy%20blue%20shadows%20with%20subtle%20warm%20amber%20highlight%2C%20soft%20film%20grain%2C%20minimal%20symmetric%20composition%2C%20high%20detail%20photography&width=600&height=800&seq=movie-silent-testimony-poster&orientation=portrait",
    tags: ["律政剧", "口碑之作"],
    featured: false,
  },
  {
    id: "beyond-orbit",
    title: "星轨之外",
    originalTitle: "Beyond the Orbit",
    type: "电影",
    region: "海外",
    year: 2025,
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.5,
    popularity: 90,
    duration: "142 分钟",
    director: "阿德里安·科尔",
    cast: ["伊莎·罗兰", "马库斯·李", "艾琳·塔克"],
    tagline: "我们花了六十年抵达那里，只为说一句对不起。",
    summary: "深空补给站的最后一名值守员，收到一条来自地球、迟到了四十年的语音。",
    synopsis: [
      "在距离地球最远的补给站，值守员每两百天才能收到一次通讯。一次例行检修中，系统解压出一条被错误归档的语音——来自四十年前，发送者是她的母亲。",
      "为了回应这条消息，她必须手动调整天线角度，这会耗尽站内仅剩的燃料。整部电影几乎只有一个演员、一个空间，却把宇宙的广阔与人的孤独同时拍了出来。",
      "影片的美术设计以极简的冷色金属与暖色舱灯对比，声音设计克制而精准。最后的长镜头里，地球只是一个模糊的光点，但所有人都知道那意味着什么。",
    ],
    updatedAt: "2025-10-05",
    poster:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20film%20poster%20portrait%20of%20a%20solitary%20astronaut%20floating%20outside%20a%20deep%20space%20station%2C%20vast%20star%20field%20and%20a%20distant%20pale%20blue%20planet%2C%20deep%20navy%20and%20cold%20metallic%20tones%20with%20warm%20amber%20cabin%20light%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20cinematic%20photography&width=600&height=800&seq=movie-beyond-orbit-poster&orientation=portrait",
    tags: ["科幻大片", "视觉震撼"],
    featured: false,
  },
  {
    id: "old-post-office",
    title: "旧日邮局",
    originalTitle: "The Old Post Office",
    type: "电视剧",
    region: "海外",
    year: 2024,
    genres: ["剧情", "温情", "年代"],
    rating: 8.2,
    popularity: 78,
    duration: "全 10 集",
    director: "米拉·安德森",
    cast: ["海伦·瓦尔", "汤姆·里德", "露西·费恩"],
    tagline: "有些信送不到，但会被好好收着。",
    summary: "小镇邮局关闭前，邮差决定把三十年里所有无法投递的信，一封封送到收件人手上。",
    synopsis: [
      "小镇邮局接到撤并通知，老邮差在整理仓库时，发现了三大箱无法投递的信件：地址错误、收件人搬离、或者根本没有邮票。",
      "他决定在退休前把它们送出去。十集的篇幅，每集一封信，串起小镇三十年的变化：离开的人、留下的人、以及那些以为早已被遗忘的约定。",
      "剧集节奏缓慢却不沉闷，用大量真实的小镇景观和生活对话，让每一封信都落在具体的人身上。最后一封信的收件人，是邮差自己。",
    ],
    updatedAt: "2025-09-22",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20series%20poster%20portrait%20of%20a%20small%20town%20post%20office%20interior%2C%20stacks%20of%20old%20letters%20on%20a%20wooden%20counter%2C%20soft%20window%20light%2C%20deep%20navy%20shadows%20with%20amber%20lamp%20glow%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20editorial%20photography&width=600&height=800&seq=movie-old-post-office-poster&orientation=portrait",
    tags: ["温情剧集", "慢节奏"],
    featured: false,
  },
  {
    id: "against-light",
    title: "逆光而行",
    originalTitle: "Walking Against the Light",
    type: "电影",
    region: "国产",
    year: 2025,
    genres: ["剧情", "励志"],
    rating: 8.1,
    popularity: 84,
    duration: "118 分钟",
    director: "罗青",
    cast: ["段野", "白露", "陈叙"],
    tagline: "不是所有坚持都有结果，但总得有人往前走。",
    summary: "一支濒临解散的县级盲人足球队，和一位被降职的教练，走完最后一个赛季。",
    synopsis: [
      "县里的盲人足球队只剩下六个人，场地被划走了一半，赞助商撤了。被降职的教练带着这群平均年龄二十七岁的队员，报名参加了省里最后一届比赛。",
      "训练场的铁丝网外没有人看，队员们在黑暗里靠声音判断球的位置。影片没有把苦难放大，也没有安排奇迹，只是把每一次摔倒和每一次站起来都拍得清清楚楚。",
      "决赛输了，比分没有被隐去。但镜头最后停在更衣室里，有人笑着说：明年还来。",
    ],
    updatedAt: "2025-10-02",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20inspirational%20film%20poster%20portrait%20of%20a%20blind%20football%20player%20walking%20toward%20strong%20backlight%20on%20a%20dusty%20field%2C%20silhouetted%20teammates%20behind%2C%20warm%20amber%20sun%20flare%20against%20deep%20navy%20shadows%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20photography&width=600&height=800&seq=movie-against-light-poster&orientation=portrait",
    tags: ["真实改编", "热血"],
    featured: false,
  },
  {
    id: "spring-equinox",
    title: "春分",
    originalTitle: "Spring Equinox",
    type: "电视剧",
    region: "国产",
    year: 2024,
    genres: ["家庭", "剧情", "生活"],
    rating: 8.3,
    popularity: 80,
    duration: "全 28 集",
    director: "温子禾",
    cast: ["许知夏", "梁川", "赵屿"],
    tagline: "白天和黑夜一样长的那天，一家人终于坐下来吃饭。",
    summary: "老宅要卖掉的前七天，三个子女回到老家，整理父亲留下的三十年杂物。",
    synopsis: [
      "春分这天，老宅要卖掉。三个子女从不同城市回到老家，处理父亲留下的东西。母亲早已去世，父亲去年也走了，房子里只剩下三十年的杂物。",
      "整理的过程变成一场缓慢的考古：一张没寄出的汇款单、一本记满名字的账本、一罐腌了太久的酱菜。每件东西都指向同一个事实——他们其实并不了解父亲。",
      "二十八集不讲大起大落，只讲一顿饭、一次争吵、一场雨。剧集用极生活化的台词，把中国家庭的沉默与牵挂拍得准确又温柔。",
    ],
    updatedAt: "2025-09-18",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%20portrait%20of%20an%20old%20Chinese%20courtyard%20house%20in%20early%20spring%2C%20blossoming%20branches%20and%20a%20wooden%20dining%20table%20visible%20through%20the%20window%2C%20soft%20warm%20daylight%20with%20deep%20navy%20shadows%2C%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20editorial%20photography&width=600&height=800&seq=movie-spring-equinox-poster&orientation=portrait",
    tags: ["家庭生活", "细腻"],
    featured: false,
  },
  {
    id: "letters-from-north",
    title: "北方来信",
    originalTitle: "Letters from the North",
    type: "电影",
    region: "海外",
    year: 2024,
    genres: ["剧情", "爱情"],
    rating: 8.4,
    popularity: 76,
    duration: "112 分钟",
    director: "英格丽·索恩",
    cast: ["艾娃·林德", "奥拉夫·森", "米娅·霍姆"],
    tagline: "雪停之前，她终于读完了最后一封信。",
    summary: "北方小镇的邮局职员，用陌生人的名义回了七年的信，直到最后一封被签收。",
    synopsis: [
      "北方小镇的冬天长达五个月。邮局职员在整理死信时，发现一封信连续七年被退回，收件地址是镇上一栋早已空置的房子。",
      "她开始回信，用那个陌生人的名义。两个从未见过面的人，通过一封封被退回的信，交换了七个冬天的生活。",
      "影片在极夜的冷光与室内的暖灯之间来回切换，安静得像一场雪。结尾没有相见，只有第八年的第一封信，终于被签收。",
    ],
    updatedAt: "2025-09-15",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20winter%20romance%20poster%20portrait%20of%20a%20snowy%20northern%20railway%20station%20at%20dusk%2C%20a%20lone%20figure%20holding%20a%20letter%2C%20deep%20navy%20blue%20snow%20shadows%20with%20warm%20amber%20station%20lamp%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20editorial%20photography&width=600&height=800&seq=movie-letters-north-poster&orientation=portrait",
    tags: ["文艺片", "冷门佳片"],
    featured: false,
  },
  {
    id: "deep-blue-chronicle",
    title: "深蓝纪事",
    originalTitle: "Deep Blue Chronicle",
    type: "电视剧",
    region: "海外",
    year: 2025,
    genres: ["纪录", "自然", "冒险"],
    rating: 9.1,
    popularity: 88,
    duration: "全 6 集",
    director: "海洋影像实验室",
    cast: ["旁白：陆川"],
    tagline: "在海平面以下三千米，光从来没有到过。",
    summary: "六集纪录片，六个深度，用两年时间记录从珊瑚礁到深海热泉的完整生态剖面。",
    synopsis: [
      "六集纪录片，六个深度。摄制组用两年时间跟随科考船，记录了从珊瑚礁到深海热泉的完整生态剖面。",
      "第四集拍摄到的深海生物发光群落，是该项目最重要的影像成果。没有戏剧化剪辑，也没有过度配乐，只有真实的黑暗与真实的光。",
      "最后一集把镜头转回海面，讲述人类活动如何改变这片深蓝。克制，但足够有力。",
    ],
    updatedAt: "2025-10-10",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20nature%20documentary%20poster%20portrait%20of%20a%20deep%20sea%20diver%20silhouette%20surrounded%20by%20bioluminescent%20particles%20in%20dark%20water%2C%20rays%20of%20faint%20light%20from%20above%2C%20deep%20navy%20and%20teal%20palette%20with%20subtle%20amber%20glow%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20underwater%20photography&width=600&height=800&seq=movie-deep-blue-poster&orientation=portrait",
    tags: ["高分纪录片", "自然"],
    featured: false,
  },
  {
    id: "seventh-letter",
    title: "第七封信",
    originalTitle: "The Seventh Letter",
    type: "电影",
    region: "国产",
    year: 2023,
    genres: ["悬疑", "剧情"],
    rating: 7.9,
    popularity: 72,
    duration: "108 分钟",
    director: "季川",
    cast: ["沈砚", "周未", "林漪"],
    tagline: "前六封信都在说谎，第七封才是遗书。",
    summary: "作家连续收到六封预告明天的信，第七封却迟迟没有来，取而代之的是一则讣告。",
    synopsis: [
      "作家在写作瓶颈期收到六封没有署名的信，每封信都准确描述了他第二天会做的事。第七封信迟迟没有来，取而代之的是一则讣告。",
      "为了弄清真相，他开始调查信件来源，却发现每一封信背后都对应着一位他曾经忽视的人。故事在虚实之间摇摆，直到最后一页被翻开。",
      "影片结构精巧，用书信体推进叙事，把悬疑与自我审视结合在一起。结尾的留白，是整部电影最锋利的地方。",
    ],
    updatedAt: "2025-08-30",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20poster%20portrait%20of%20a%20wooden%20writing%20desk%20with%20seven%20sealed%20letters%20and%20a%20warm%20desk%20lamp%20in%20a%20dark%20room%2C%20deep%20navy%20shadows%20with%20amber%20light%20pool%2C%20soft%20film%20grain%2C%20minimal%20top%20down%20composition%2C%20high%20detail%20editorial%20photography&width=600&height=800&seq=movie-seventh-letter-poster&orientation=portrait",
    tags: ["烧脑", "书信体"],
    featured: false,
  },
  {
    id: "night-boat",
    title: "夜航船",
    originalTitle: "The Night Ferry",
    type: "电视剧",
    region: "国产",
    year: 2024,
    genres: ["悬疑", "年代", "剧情"],
    rating: 8.5,
    popularity: 86,
    duration: "全 20 集",
    director: "顾长风",
    cast: ["谢行", "柳青", "孟舟"],
    tagline: "船上十二个人，每个人都有不能说的目的地。",
    summary: "民国年间一艘夜航客船，十二名陌生乘客，天亮相时少了一个人。",
    synopsis: [
      "民国年间，一艘夜航客船从上游出发，要在天亮前抵达下游港口。船上十二名乘客互不相识，却都买了同一天的票。",
      "第一夜，船在江心停了一次，没有人知道为什么。第二天清晨，一名乘客消失了，而所有人的船票上，都多了一道相同的划痕。",
      "二十集的篇幅几乎全部发生在船上，空间调度极具张力。故事到最后回到岸上，才发现真正漫长的航行，是人心里的那一段。",
    ],
    updatedAt: "2025-09-25",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20period%20mystery%20poster%20portrait%20of%20an%20old%20wooden%20passenger%20ferry%20on%20a%20dark%20river%20at%20night%2C%20warm%20lantern%20light%20glowing%20from%20cabin%20windows%2C%20deep%20navy%20mist%20and%20reflections%2C%20soft%20film%20grain%2C%20minimal%20composition%2C%20high%20detail%20photography&width=600&height=800&seq=movie-night-boat-poster&orientation=portrait",
    tags: ["年代悬疑", "群像"],
    featured: false,
  },
];

export const movieGenres = [
  "剧情",
  "悬疑",
  "犯罪",
  "家庭",
  "爱情",
  "科幻",
  "青春",
  "律政",
  "纪录",
  "励志",
];

export const yearOptions = [2025, 2024, 2023];